import { Search } from '@mui/icons-material';
import { SxProps } from '@mui/material';
import { useContext } from 'react';

import { TemplatePlaceholder } from '@/types';
import { AccordionField } from '@components/DrawerAccordion';
import { SearchTemplatePageContext } from '@/context/SearchTemplateContext';
import TemplateCapableFetchAutocomplete, {
  TemplateCapableFetchAutocompleteChangeReason,
} from '@/pages/AdvancedSearchListCreatorPage/customWidgets/templateCapableComponents/TemplateCapableFetchAutocomplete';
import { useLookupLists } from '@/criteriaLookups';
import { ListRecordResult } from '@/types/filterCriteriaRecords';

type ListProps = {
  onChange: (
    newValue: ListRecordResult[] | TemplatePlaceholder,
    reason: TemplateCapableFetchAutocompleteChangeReason
  ) => void;
  value: ListRecordResult[] | TemplatePlaceholder;
  listLabel?: string;
  sx?: SxProps;
  error?: boolean;
};

const Lists = ({
  value = [] as ListRecordResult[],
  onChange = () => {},
  listLabel = 'Find a list',
  sx,
  error,
}: ListProps) => {
  const lookupLists = useLookupLists();
  const isOnTemplatePage = useContext(SearchTemplatePageContext);

  return (
    <AccordionField>
      <TemplateCapableFetchAutocomplete
        error={error}
        lookup={lookupLists}
        minLength={3}
        label={listLabel}
        value={value}
        onChange={onChange}
        data-testid={listLabel}
        loadingText="Looking for lists..."
        noOptionsText="No lists found"
        popupIcon={<Search />}
        disableIconFlip
        sx={sx}
        isOnTemplatePage={isOnTemplatePage}
        templateBuilderDisplayName="Calling status filter: List(s)"
      />
    </AccordionField>
  );
};

export default Lists;
